var map = {
	"./chat-with-doctor.svg": 25714,
	"./doctor.svg": 9040,
	"./family.svg": 62780,
	"./files.svg": 52527,
	"./glucose.svg": 76457,
	"./home.svg": 14325,
	"./menstruation-calendar.svg": 9369,
	"./my-family.svg": 96694,
	"./plus.svg": 6724,
	"./pregnancy.svg": 42755,
	"./pressure.svg": 12401,
	"./service.svg": 54748,
	"./stethoscope.svg": 71101,
	"./tablets-calendar.svg": 94684,
	"./vaccination.svg": 91476,
	"./wallet.svg": 36019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96391;